import { Boolean, Number, Record, Static, String } from 'runtypes'
import { DateString } from 'src/shared/contract/date'

/**
 * Stock record type
 */
export const Stock = Record({
    id: Number,
    title: String,
    name: String,
    city: String,
    isMetroLocation: Boolean,
    address: String,
    coordinates: String,
    optTimeFrom: DateString,
    optTimeTo: DateString,
    metroColor: String,
    showPriority: Number,
    isOpened: Boolean,
    cityId: Number,
    timeString: String,
    isNew: Boolean,
    tradingCenterTitle: String.nullable(),
    coordinateX: Number,
    coordinateY: Number
})

/**
 * Stock type
 */
export type IStock = Static<typeof Stock>
